import { useEffect, useState } from 'react';
import { QuoteInsurancePoliciesQuery } from '../../../../../../../gql/graphql';
import { groupCoverages, GroupedCoverages } from './utility';
import {
  ComparePropertyCoverages,
  CompareCoverages,
  CompareAdditionalCoverages,
} from './CompareCoverages';

type PolicyType = NonNullable<
  NonNullable<QuoteInsurancePoliciesQuery['quoteInsurancePolicies']>[number]
>;

interface ComparePolicyProps {
  policy: PolicyType | null;
  comparisonPolicy: PolicyType | null;
}

export const ComparePolicy = ({
  policy,
  comparisonPolicy,
}: ComparePolicyProps) => {
  const [comparisonGrouped, setComparisonGrouped] =
    useState<GroupedCoverages | null>(null);
  const [policyGrouped, setPolicyGrouped] = useState<GroupedCoverages | null>(
    null,
  );

  useEffect(() => {
    if (comparisonPolicy) {
      setComparisonGrouped(groupCoverages(comparisonPolicy.coverages || []));
    } else {
      setComparisonGrouped(null);
    }
  }, [comparisonPolicy]);

  useEffect(() => {
    if (policy) {
      setPolicyGrouped(groupCoverages(policy.coverages || []));
    } else {
      setPolicyGrouped(null);
    }
  }, [policy]);

  if (!comparisonGrouped && !policyGrouped) {
    return null;
  }
  return (
    <>
      <ComparePropertyCoverages
        comparisonPropertyByLocation={
          comparisonGrouped?.propertyByLocation || new Map()
        }
        policyPropertyByLocation={
          policyGrouped?.propertyByLocation || new Map()
        }
      />
      <CompareCoverages
        label='Liability'
        quoteCoverages={policyGrouped?.liability || []}
        comparisonCoverages={comparisonGrouped?.liability || []}
      />
      <CompareAdditionalCoverages
        quotePerils={policyGrouped?.misc || []}
        comparisonPerils={comparisonGrouped?.misc || []}
      />
    </>
  );
};
